import React, { useState, useEffect } from "react";
import "./DisplayCategories.css";
import { NavLink, useNavigate } from "react-router-dom";
import { Products } from "../Products";
import axiosConfig from "../../Service/axiosConfig";

const DisplayCategories = ({ Setlogin, LoginAccount, data }) => {
  const [loading, setLoading] = useState(false);
  const [banners, setBanners] = useState([]); // State to hold banner images
  let navigate = useNavigate();

  // Fetch banner data from the API
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        setLoading(true);
        const response = await axiosConfig.get(
          "/catlog/banners/?banner_type=middle_banners&is_suspended=false"
        );
        setBanners(response.data.results); // Assuming `results` is an array of banners
        setLoading(false);
      } catch (error) {
        console.error("Error fetching banners:", error);
        setLoading(false);
      }
    };

    fetchBannerImages();
  }, []);

  return (
    <>
      <div className="">
        {loading ? (
          <div className="loader-container">
            <img src={require("../images/loader.gif")} alt="Loading..." />
          </div>
        ) : (
          <div className="display-categories">
            {data.length >= 1 &&
              data.map((itemObj, index) => {
                return (
                  <React.Fragment key={itemObj.id}>
                    {/* Render the Products component */}
                    <Products
                      products_for={itemObj.name}
                      filter_id={itemObj.sub_id}
                      product_slug={itemObj.sub_slug}
                      Setlogin={Setlogin}
                      LoginAccount={LoginAccount}
                    />
                    {/* Add image after the second category */}
                    {index === 1 && banners.length > 2 && (
                      <div className="category-banner">
                        <img
                          src={banners[0].image.image} // Update according to the API structure
                          alt="Category Banner"
                          height={200}
                          width={1120} className="middle_banner"
                          onClick={()=>navigate(`${banners[0].slug}`)}
                        />
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
};
export { DisplayCategories };
